export default __webpack_public_path__ + "static/media/marches-financiers.b980bcaf.svg";